import api from "api";
import ApiCaller from "api/apiCaller";
import React, { useState, useEffect } from "react";
import { UserInfo } from "model/user";
import {
    Button,
    Col,
    Row,
    Container,
    Table
} from "reactstrap";
import {AlertConfig, UserFilter} from "model/alerting";
import { ToggleButton } from "components/ToggleButton";
import AlertItem from './components/AlertItem'
import "./index.css";
import Loading from "components/Loading";
import ReactPaginate from "react-paginate";
import Select from "react-select";


const DEFAULT_PAGE_LIMIT = 25;
interface ListingData {
  alerts: Array<AlertConfig>;
  total: number;
  users_filter: Array<UserFilter>;
}

type OptionType = { value: string, label: string };

export default function AlertListing() {
  const companyId: any = api.getCurrentCompanyId();
  const [currentUser, setCurrentUser] = useState<UserInfo | null>(null)
  const [listingData, setListingData] = useState<ListingData>({
    alerts: [],
    total: 0,
    users_filter: []
  });
  const [page, setPage] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [pageLimit, setPageLimit] = useState<number>(DEFAULT_PAGE_LIMIT);
  const pageLimitOptions = [
    { 'value': 25, 'label': '25'},
    { 'value': 50, 'label': '50'},
    { 'value': 75, 'label': '75'},
    { 'value': 100, 'label': '100'},
  ]

  const [showActiveAlertOnly, setShowActiveAlertOnly] = useState(false);
  const [userFilter, setUserFilter] = useState('');

  const initData = async () => {
    const user = api.getCurrentUser();
    setCurrentUser(user);
  };

  const getAlerts = async () => {
    let isActive = '';
    if (showActiveAlertOnly) {
      isActive = '1'
    }

    const res:any = await ApiCaller.get(
      `monitoring/alerting?company_id=${companyId}&limit=${pageLimit}&page=${page}` +
      `&sort_by=changed_on&sort_type=desc&is_active=${isActive}&created_by_fk=${userFilter}`
    );
    const data = res?.data;
    if (res?.status === "ok") {
      setListingData({
        ...listingData,
        ...{
          alerts: data?.alerts,
          total: data?.total,
          users_filter: data?.users_filter
        },
      });
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const handleActiveStatusSwitchChange = (nextChecked: boolean) => {
    setShowActiveAlertOnly(nextChecked);
  }

  const goToAlertSetup = () => {
    window.location.href = `/monitoring/alerting/create/1`;
	};

  useEffect(() => {
    initData();
  }, []);

  useEffect(() => {
    getAlerts();
  }, [pageLimit, page, showActiveAlertOnly, userFilter]);

  if (loading) return <Loading />;

  return (
    <Container className='alerting-listing__container'>
      <Row>
        <Col className="home-current-user-brand" xs={12}>
          <h3>
            {
              currentUser?.companies.find((comapny) => comapny.id == companyId)
                ?.name
            } Alerting
          </h3>
        </Col>
      </Row>
      <Row>
        <Col xs={9}>
          <Button
            color="primary"
            className="alerting-listing__control-buttons"
            onClick={goToAlertSetup}
          >
            <span className="material-icons">add</span>
            <span>Create new alert</span>
          </Button>
          <br />
        </Col>
      </Row>
      <Row className="alerting-listing__filter">
        <Col xs={4}>
          <Select
            options={listingData.users_filter?.map((user: UserFilter) => (
              { value: user.user_id, label: user.username }
            ))}
            onChange={(selectedOption: any) => {
              if (selectedOption) {
                setUserFilter(selectedOption.value);
              } else {
                setUserFilter('')
              }
                setPage(0);
              }
            }
            isClearable
            placeholder='Created By'
          />
        </Col>
        <Col>
          <ToggleButton
            id="alert-show-active-only"
            className="alert-show-active-only__switch"
            handleSwitchChange={handleActiveStatusSwitchChange}
            checked={showActiveAlertOnly}
            label="Show active only"
          />
        </Col>
      </Row>
      <Table hover responsive>
        <thead>
          <tr>
            <th>Name</th>
						<th>Schedule</th>
            <th>Last modified by</th>
						<th>Last modified on</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
        {listingData?.alerts?.map((alert:AlertConfig) => {
          return (
            <AlertItem key={alert.id} alertData={alert}/>
          );
        })}
        </tbody>
      </Table>
      <Row>
        <Col xs={11}>
          <span></span>
          <ReactPaginate
            previousLabel={"<"}
            nextLabel={">"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={Math.floor(listingData?.total / pageLimit) + 1}
            marginPagesDisplayed={3}
            pageRangeDisplayed={2}
            initialPage={0}
            onPageChange={async (page) => {
              setListingData({
                ...listingData,
              });
              setPage(page.selected);
            }}
            forcePage={page}
            containerClassName={"pagination"}
            activeClassName={"active"}
          />
        </Col>
        <Col xs={1} className='alerting-listing__filter'>
          <Select
            options={pageLimitOptions}
            onChange={(selectedOption: any) => {
                setPageLimit(selectedOption.value);
                setPage(0);
              }
            }
            defaultValue={pageLimitOptions[0]}
            menuPlacement="auto"
          />
        </Col>
      </Row>
    </Container>
  );
}
